import { OfflineQueueItem, Timestamp, UUID } from './chores';

/** The chores and households the offline queue still refers to: created, changed or completed on
 * this device and not yet (or not successfully) pushed, so the server may not have them yet. */
export function pendingIds(queue: OfflineQueueItem[]): { choreIds: Set<UUID>; householdIds: Set<UUID> } {
  const choreIds = new Set<UUID>();
  const householdIds = new Set<UUID>();
  for (const item of queue) {
    if (item.choreId) choreIds.add(item.choreId);
    if (item.householdId) householdIds.add(item.householdId);
  }
  return { choreIds, householdIds };
}

/**
 * Which local records a full fetch from the server shows to be gone: the ones the server no
 * longer has, which a deletion's soft-delete marker can't report (a document deleted outright,
 * as chores were before soft delete, or a household left or deleted on another device).
 *
 * Kept, though missing from the server: anything the offline queue still refers to, and anything
 * created at or after `fetchStartedAt`, which the fetch could not have seen.
 */
export function findStaleIds(
  local: { id: UUID; created_at?: Timestamp }[],
  remoteIds: Iterable<UUID>,
  pending: Set<UUID>,
  fetchStartedAt: Date,
): UUID[] {
  const remote = new Set(remoteIds);
  return local
    .filter(record => !remote.has(record.id) && !pending.has(record.id))
    .filter(record => !record.created_at || new Date(record.created_at) < fetchStartedAt)
    .map(record => record.id);
}
